import React from 'react';
import {eventKeyConstants} from "../../../utils/eventKey";
import { withTranslation } from 'react-i18next';
export default withTranslation()(class SurveyYesNo extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			yesBtn: 'displayUpdateTertiaryBtn-cancel',
			noBtn: 'displayUpdateTertiaryBtn-cancel',
		};
		this.btnClicked = this.btnClicked.bind(this);
	}

	keyDownHandler = (e, val) => {
		switch(e.key){
			case eventKeyConstants.ARROWUP:
			case eventKeyConstants.ARROWRIGHT:
			case eventKeyConstants.ARROWDOWN:
			case eventKeyConstants.ARROWLEFT:
				e.preventDefault();
				let el = $(e.target).siblings('[role=radio]');
				el.focus()
				this.btnClicked(val === '2' ? '1' : '2');
				break;
			case eventKeyConstants.ENTER:
			case eventKeyConstants.SPACE:
				e.preventDefault();
				this.btnClicked(val);
				break;
		}
	  }

	btnClicked(selVal, clsVal) {
		const mId = this.props.metricId;
		const mdId = this.props.metricDataId;
		const surveyHidInpId = `updateKRMetDataYesNoId_${mdId}`;
		$(`#${surveyHidInpId}`).val(selVal);
		this.setState({
			yesBtn: (selVal == '1') ? 'displayUpdateTertiaryBtn-cancel' : '',
			noBtn: (selVal == '1') ? '' : 'displayUpdateTertiaryBtn-cancel',
		});
	}

	render() {
		const mId = this.props.metricId;
		const mdId = this.props.metricDataId;
		const surveyHidInpId = `updateKRMetDataYesNoId_${mdId}`;
		const { t } = this.props
		return (
			<div>
				<input type="hidden" name={`metric[${mId}][${mdId}][val]`} id={surveyHidInpId} />
				<div className="displayInlineB" role="radiogroup" aria-labelledby={`confKRMetricName-${this.props.metricId}`}>
					<div className={`displayInlineB displayUpdateTertiaryBtn ${this.state.yesBtn}`}
						onClick={() => this.btnClicked('2')}
						aria-checked={this.state.yesBtn === ''}
						tabIndex={(this.state.yesBtn === '' || this.state.noBtn !== '') ? 0 : -1}
						role="radio"
						onKeyDown={(e) =>{ this.keyDownHandler(e, '2')}}
						data-testid="yes-btn-updateKR-due"
					>
						{t('Yes')}
					</div>
					<div className={`displayInlineB displayUpdateTertiaryBtn ${this.state.noBtn}`} 
						style={{marginLeft:"8px"}}
						onClick={() => this.btnClicked('1')}
						aria-checked={this.state.noBtn === ''}
						tabIndex={this.state.noBtn === '' ? 0 : -1}
						role="radio"
						onKeyDown={(e) =>{ this.keyDownHandler(e, '1')}}
						data-testid="no-btn-updateKR-due"
					>
						{t('No')}
          			</div>
				</div>
			</div>
		);
	}
})